import { generateMockId } from '@gp/utils/common';
import { checkRepeatTags } from '@gp/components/CustomizeTagInput/utils';

import type { ICustomizeTagInputValue } from '@gp/components/CustomizeTagInput/types';
import type { ICustomizeTagInputValidation } from '@gp/components/CustomizeTagInput';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const generateCustomizeAddOptionValueDefault = (_?: string): string => generateMockId();

const generateCustomizeAddOptionDataDefault = (_value?: string, _text?: string): any => {};

export const convert2SelectOptionValue = (
  tagInputValue?: ICustomizeTagInputValue | null,
  options?: {
    ignoreCase?: boolean;
    existedTags?: string[] | null;
    validateCustomizeTag?: (tag?: string) => ICustomizeTagInputValidation;
    generateCustomizeAddOptionValue?: (text?: string) => string;
    generateCustomizeAddOptionData?: (value?: string, text?: string) => unknown;
  },
): false | IGPSelectOption[] => {
  const { tags, input } = tagInputValue || {};
  const {
    validateCustomizeTag,
    generateCustomizeAddOptionValue = generateCustomizeAddOptionValueDefault,
    generateCustomizeAddOptionData = generateCustomizeAddOptionDataDefault,
    ...restOptions
  } = options || {};
  if (!!validateCustomizeTag?.(input)?.invalid) return false;
  const isRepeat = checkRepeatTags(tags, input, restOptions);
  if (isRepeat) return false;
  if (!Array.isArray(tags) || !tags.length) {
    if (!input) return [];
    const valueTmp = generateCustomizeAddOptionValue(input);
    // @ts-ignore
    return [{ value: valueTmp, text: input, label: input, data: generateCustomizeAddOptionData?.(valueTmp, input) }];
  }
  const tagsTmp = !input ? tags : [...tags, input];
  // @ts-ignore
  return tagsTmp.map((tagTmp) => {
    const valueTmp = generateCustomizeAddOptionValue(tagTmp);
    return {
      value: valueTmp,
      text: tagTmp,
      label: tagTmp,
      data: generateCustomizeAddOptionData?.(valueTmp, tagTmp),
    };
  });
};
